<template>
  <div class="surface">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="['PrescriptionList']">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import { downloadByLink } from '@/util';
export default {
  provide() {
    return {
      _prescription: this
    };
  },
  data() {
    return {
      batchIds: [] // 勾选的处方id
    };
  },
  methods: {
    // 删除处方
    delPrescription(ids) {
      return this.$confirm('确认删除所选处方吗？确认后不可撤销操作。').then(() => {
        return Fetch.deletePrescription({ ids }).then(res => {
          this.$message.success('操作成功，预计10秒左右生效');
        });
      });
    },
    // 下载单张pdf
    downLoadOne(id, queryDownload) {
      const query = `pid=${id}&${queryDownload}`;
      const url = `${Util.getApiRoot}/pr/load/file?${query}`;
      downloadByLink(url, id);
    }
  }
};
</script>
<style lang="scss" scoped>
.surface {
  .dialog-warp {
    /deep/ .el-dialog {
      min-width: 360px;
      padding: 0 20px;
      .el-dialog__body {
        padding: 0;
        .el-radio {
          margin-right: 10px;
          display: inline-block;
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: center;
        .el-button {
          flex: 1;
          max-width: 150px;
        }
      }
    }
  }
}
</style>
